import { Injectable } from '@angular/core';

const TOKEN_KEY = 'AuthToken';
const LOGIN = 'Login';
const USER_PROFILE = 'USER_PROFILE';
const USER_ID = 'USER_ID';

@Injectable()
export class TokenStorage {

    constructor() { }

    signOut() {
        window.sessionStorage.removeItem(TOKEN_KEY);
        window.sessionStorage.removeItem(USER_PROFILE);
        window.sessionStorage.removeItem(LOGIN);
        window.sessionStorage.clear();
    }

    public saveToken(token: string) {
        window.sessionStorage.removeItem(TOKEN_KEY);
        window.sessionStorage.setItem(TOKEN_KEY,  token);
    }

    public removeToken(){
        window.sessionStorage.removeItem(TOKEN_KEY);
    }
    
    public getToken(): string {
        return sessionStorage.getItem(TOKEN_KEY);
    }

    public getLogin(): string {
        return sessionStorage.getItem(LOGIN);
    }

    public saveLogin(login: string) {
        window.sessionStorage.removeItem(LOGIN);
        window.sessionStorage.setItem(LOGIN,  login);
    }


    public getUserProfile(): string {
        return sessionStorage.getItem(USER_PROFILE);
    }

    public saveUserProfile(profile: string) {
        window.sessionStorage.removeItem(USER_PROFILE);
        window.sessionStorage.setItem(USER_PROFILE,  profile);
        //console.log("Hummm PROFILE SAVE");
    }

    public getUserID(): string {
        return sessionStorage.getItem(USER_ID);
    }

    public saveUserID(id: string) {
        window.sessionStorage.removeItem(USER_ID);
        window.sessionStorage.setItem(USER_ID,  id);
        //console.log("Hummm ID SAVE");
    }

    public removeUserID() {
        window.sessionStorage.removeItem(USER_ID);
      
       // console.log("Hummm PROFILE SAVE");
    }
}


// WEBPACK FOOTER //
// ./src/app/core/token.storage.ts